import React from 'react';

function TermsOfUse() {
  return (
    <div style={{ maxWidth: '800px', margin: '40px auto', padding: '20px', lineHeight: '1.8', direction: 'rtl', textAlign: 'right' }}>
      <div style={{ backgroundColor: 'white', borderRadius: '15px', padding: '40px', boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)' }}>
        <h1 style={{ fontSize: '2rem', marginBottom: '1.5rem', color: '#333' }}>תנאי שימוש</h1>
        
        <div style={{ backgroundColor: '#fff3cd', border: '2px solid #ffc107', borderRadius: '8px', padding: '20px', marginBottom: '30px' }}>
          <h2 style={{ fontSize: '1.3rem', marginTop: '0', color: '#856404' }}>⚠️ הצהרה חשובה</h2>
          <p style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#856404', marginBottom: '10px' }}>
            מחשבון זה מיועד למטרות מידע בלבד ואינו מהווה ייעוץ מס מקצועי, ייעוץ משפטי, ייעוץ כלכלי או ייעוץ פיננסי.
          </p>
          <p style={{ color: '#856404' }}>
            התוצאות המוצגות הן הערכות בלבד ועלולות להיות שונות מהמציאות. יש להיוועץ עם רואה חשבון מוסמך או יועץ מס לפני קבלת החלטות חשובות.
          </p>
        </div>

        <h2 style={{ fontSize: '1.3rem', marginTop: '2rem', marginBottom: '1rem', color: '#333' }}>שימוש באחריותך בלבד</h2>
        <p style={{ color: '#555', fontSize: '1rem' }}>
          השימוש במחשבון זה הוא על אחריותך הבלעדית. אנו לא מתחייבים לדיוק התוצאות ולא נהיה אחראים לנזקים כלשהם הנובעים משימוש או סמיכות על התוצאות.
        </p>

        <h2 style={{ fontSize: '1.3rem', marginTop: '2rem', marginBottom: '1rem', color: '#333' }}>התייעצות מקצועית</h2>
        <p style={{ color: '#555', fontSize: '1rem' }}>
          יש להיוועץ עם רואה חשבון מוסמך או יועץ מס לפני קבלת החלטות כלכליות או מס חשובות. מחשבון זה אינו מחליף ייעוץ מקצועי.
        </p>

        <h2 style={{ fontSize: '1.3rem', marginTop: '2rem', marginBottom: '1rem', color: '#333' }}>מקורות המידע</h2>
        <p style={{ color: '#555', fontSize: '1rem' }}>
          החישובים מבוססים על שיעורי מס וביטוח לאומי לשנת 2026. שיעורי המס משתנים מדי שנה ויש לבדוק את השיעורים העדכניים במקורות הרשמיים.
        </p>

        <div style={{ marginTop: '30px', padding: '20px', backgroundColor: '#f5f5f5', borderRadius: '8px', textAlign: 'center' }}>
        <button 
          onClick={() => window.location.hash = ''} 
          style={{
            padding: '12px 30px',
            backgroundColor: '#667eea',
            color: 'white',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            fontSize: '16px',
            fontWeight: 'bold',
            transition: 'all 0.3s ease'
          }}
          onMouseOver={(e) => e.target.style.backgroundColor = '#5568d3'}
          onMouseOut={(e) => e.target.style.backgroundColor = '#667eea'}
        >
          חזור למחשבון
        </button>
        </div>
      </div>
    </div>
  );
}

export default TermsOfUse;
